export const getValuesByKey = <Type extends Object>(
  objType: Type,
  value: string | number
): Type[keyof Type] | undefined => Object.entries(objType)?.find(([key]) => key === value)?.[1];
